import React from 'react';

import { unit } from '@zego/theme';

import Spacer from '@zego/components/atoms/Spacer';
import Interpose from '@zego/components/Interpose';

const FormFieldGroup = ({ children, spacing = 5 }) => (
  <Interpose separator={<Spacer height={unit(spacing)} />}>
    {children}
  </Interpose>
);

export default FormFieldGroup;
